import React from 'react';
import { useSelector } from 'react-redux';
import PracticesList from '../PracticeManagement/PracticesList/PracticesList';
import SystemCaregiverManagement from '../PracticeManagement/SystemCaregiverManagement/SystemCaregiverManagement';
import './SystemCaregiverDashboard.css';

const SystemCaregiverDashboard = () => {
  const { user } = useSelector((state) => state.auth);

  // If user is a System Caregiver (Role 7), show their assigned practices
  // Otherwise (Admins), show the System Caregiver Management list
  const isSystemCaregiver = user?.role_id === 7;

  return (
    <div className="system-caregiver-dashboard-feature">
      {isSystemCaregiver ? (
        <PracticesList />
      ) : (
        <SystemCaregiverManagement />
      )}
    </div>
  );
};

export default SystemCaregiverDashboard;
